import { OrderSubmissionContacts } from 'modules/onboarding/common/components/OrderSubmissionContacts';

import { useOwnerOrderSubmissionContacts } from '../hooks';
import { PageComponentProps } from '../types';

export const OwnerOrderSubmissionContactsStep = ({
  canGoBack,
}: PageComponentProps) => {
  const { goToBack, initialValues, onSubmit, submitLoading } =
    useOwnerOrderSubmissionContacts();

  return (
    <OrderSubmissionContacts
      canGoBack={canGoBack}
      initialValues={initialValues}
      submitLoading={submitLoading}
      onGoBack={goToBack}
      onSubmit={onSubmit}
    />
  );
};
